var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H1.66667C0.75 0 0.00833333 0.75 0.00833333 1.66667L0 11.6667C0 12.5833 0.75 13.3333 1.66667 13.3333H15C15.9167 13.3333 16.6667 12.5833 16.6667 11.6667V1.66667C16.6667 0.75 15.9167 0 15 0ZM14.6667 3.54167L8.775 7.225C8.50833 7.39167 8.15833 7.39167 7.89167 7.225L2 3.54167C1.91644 3.49476 1.84327 3.43138 1.78491 3.35538C1.72655 3.27937 1.68422 3.19231 1.66048 3.09948C1.63674 3.00664 1.63209 2.90995 1.6468 2.81526C1.66151 2.72057 1.69528 2.62984 1.74607 2.54858C1.79686 2.46732 1.8636 2.39721 1.94227 2.3425C2.02094 2.28778 2.10989 2.24959 2.20375 2.23025C2.2976 2.2109 2.3944 2.21081 2.4883 2.22996C2.58219 2.24911 2.67122 2.28711 2.75 2.34167L8.33333 5.83333L13.9167 2.34167C13.9954 2.28711 14.0845 2.24911 14.1784 2.22996C14.2723 2.21081 14.3691 2.2109 14.4629 2.23025C14.5568 2.24959 14.6457 2.28778 14.7244 2.3425C14.8031 2.39721 14.8698 2.46732 14.9206 2.54858C14.9714 2.62984 15.0052 2.72057 15.0199 2.81526C15.0346 2.90995 15.0299 3.00664 15.0062 3.09948C14.9824 3.19231 14.9401 3.27937 14.8818 3.35538C14.8234 3.43138 14.7502 3.49476 14.6667 3.54167Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.1ed330db617dc6bf434cf5983aa854a4.svg";
export { ForwardRef as ReactComponent };